var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"payment-processing"},[_c('div',{staticClass:"payment-processing__content"},[_c('CreditCardLoader',{attrs:{"card":_vm.getCardInfo}}),_c('div',{staticClass:"payment-processing__icon-loader",class:{
        'payment-processing__icon-loader--active': _vm.hasSpinnerIconLoader,
        'payment-processing__icon-loader--visible': _vm.isSpinnerIconLoaderVisible
      }},[_c('VSpinnerIconLoader',{attrs:{"loaderOptions":_vm.vSpinnerIconLoaderOptionsMock}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }